export default __webpack_public_path__ + "static/media/reloj-arena.cf1293a9.gif";